import { types } from "../actions";
import { LICENSE_ACTION_TYPES } from "../../global/constants/licensesConstants";

const initialState = {
  billingAccounts: [],
  ecpdId: "",
  ecpdAccountName: "",
  billingAccountsLoaded: false,
  licenses: [],
  otherAppLicenses: [],
  licensesLoaded: false,
  licenseLoadedOrigin: "",
  changeLicenseTypeSuccess: null,
  changeLicenseTypeFailure: false,
  assignLicenseSuccess: null,
  assignLicenseFailure: false,
  selectedLicenseRecord: null,
  fovByLicenseCache: {},
  isV1OnlyAccount: false
};

const licenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_BILLING_ACCOUNTS_LICENSES":
      return {
        ...state,
        billingAccountsLoaded: false
      };
    case "PUT_BILLING_ACCOUNTS_LICENSES":
      return {
        ...state,
        billingAccounts: action.billingAccounts,
        ecpdId: action.ecpdId || "",
        ecpdAccountName: action.ecpdAccountName || "",
        billingAccountsLoaded: true
      };
    case "PUT_LICENSES_OF_ACCOUNT":
      return {
        ...state,
        licenses: action.licenses,
        otherAppLicenses: action.otherAppLicenses || [],
        licensesLoaded: true,
        licenseLoadedOrigin: action.origin,
        isV1OnlyAccount: action.isV1OnlyAccount || false
      };
    case "PUT_LICENSES_OF_ACCOUNT_BY_ID":
      return {
        ...state,
        licensesOfAccounts: action.licenses
      };
    case "CHANGE_LICENSE_TYPE_SUCCESS":
      return {
        ...state,
        changeLicenseTypeSuccess: action.payload
      };
    case "CHANGE_LICENSE_TYPE_FAILURE":
      return {
        ...state,
        changeLicenseTypeFailure: true
      };
    case LICENSE_ACTION_TYPES.ASSIGN_LICENSE_SUCCESS:
      return {
        ...state,
        assignLicenseSuccess: action.payload,
        assignLicenseFailure: false
      };
    case LICENSE_ACTION_TYPES.ASSIGN_LICENSE_FAILURE:
      return {
        ...state,
        assignLicenseFailure: true
      };
    case "RESET_CHANGE_LICENSE_TYPE":
      return {
        ...state,
        changeLicenseTypeSuccess: null,
        changeLicenseTypeFailure: false
      };
    case LICENSE_ACTION_TYPES.SET_SELECTED_LICENSE_RECORD:
      return {
        ...state,
        selectedLicenseRecord: action.payload
      };
    case LICENSE_ACTION_TYPES.SET_FOV_BY_LICENSE_CACHE:
      return {
        ...state,
        fovByLicenseCache: {
          ...state.fovByLicenseCache,
          [action.cacheKey]: action.data
        }
      };
    case LICENSE_ACTION_TYPES.INVALIDATE_FOV_BY_LICENSE_CACHE:
      return {
        ...state,
        fovByLicenseCache: {}
      };
    default:
      return state;
  }
};

export default licenseReducer;
